import axios from 'axios';
import { AxiosError } from 'axios';
import { processAxiosError } from '../../utils/AxiosInterceptors/ErrorInterceptor';
import { CommonResult, OK, SERVICE_TEMPORARILY_UNAVAILABLE } from '../Common';

const endpoint = process.env.REACT_APP_API_URL;
const URL = `${endpoint}/mail/optInInfo`;

export interface CheckOptInMailApiResponse {
  result: CommonResult;
  checkResult: boolean;
  updateDatetime: string;
}

export interface CheckOptInMailApiRequest {
  customerId: number;
  optInToken: string;
}

export interface UpdateOptInInfoApiResponse {
  result: CommonResult;
}

export interface UpdateOptInInfoApiRequest {
  customerId: number;
  mailPermissionType: string;
  updateDatetime: string;
}

export interface OptInInfoApiRequest {
  customerId: number;
  optInMailType: string;
}

export interface OptInInfoApiResponse {
  genreId: string;
  genreName: string;
  mailMessage: string;
  mailSubject: string;
  agencyName: string;
  agencyTelNo: string;
  optInOperateUrl: string;
  result: CommonResult;
}

/**
 * オプトインメール有効性確認API
 */
export async function getCheckOptInMailApi(request: CheckOptInMailApiRequest): Promise<CheckOptInMailApiResponse> {
  try {
    const response = await axios.get(`${URL}?customerId=${request.customerId}&optInToken=${request.optInToken}`);
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      case SERVICE_TEMPORARILY_UNAVAILABLE.status:
        return data;
      default:
        throw new Error();
    }
  } catch (error) {
    const errorResponse = processAxiosError(error as AxiosError);
    return {
      ...errorResponse.data,
      updateDatetime: '',
      checkResult: false,
    };
  }
}

/**
 * オプトイン承諾情報更新API
 * @param request リクエスト
 */
export async function updateOptInInfoApi(request: UpdateOptInInfoApiRequest): Promise<UpdateOptInInfoApiResponse> {
  try {
    const response = await axios.patch(URL, request);
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      case SERVICE_TEMPORARILY_UNAVAILABLE.status:
        return data;
      default:
        throw new Error();
    }
  } catch (error) {
    const errorResponse = processAxiosError(error as AxiosError);
    return {
      ...errorResponse.data,
    };
  }
}
